import React from 'react';
import PropTypes from 'prop-types';
import TripTypeSelect from '../QuickQuote/TripTypeSelect';

const TripType = ({ selectedType, onTypeChange, onSetLocationType }) => {
  const tripTypes = [
    { id: 'to-cruise', label: 'To Cruise' },
    { id: 'from-cruise', label: 'From Cruise' },
    { id: 'round-trip', label: 'Round Trip' },
    { id: 'multi-city', label: 'Multi-City' }
  ];

  const handleTripTypeSelect = (value) => {
    onTypeChange(value);
    if (value.id == 'round-trip' || value.id == 'multi-city') {
      onSetLocationType('direct');
    }
  }

  return (
    <>
      <div className="flex flex-wrap justify-center gap-4 mt-4 w-100 mb-3 sm:hidden">
        <TripTypeSelect
            placeholder={tripTypes[0]}
            options={tripTypes}
            selectedTripType={selectedType}
            onSelect={handleTripTypeSelect}
            errorText={'You must enter an address before selecting port'}
        />
      </div>
      <div className="sm:flex flex-wrap justify-center gap-4 mt-4 w-100 mb-3 hidden">
        {console.log('Selected Type:', selectedType)}
        {tripTypes.map((type) => (
          <label
            key={type.id}
            className={`flex items-center whitespace-nowrap gap-2 cursor-pointer
              ${selectedType.id == type.id ? 'border-b-2 border-green-500 font-semibold' : ''}`}
          >
            <input
              type="radio"
              name="tripType"
              value={type.id}
              checked={selectedType.id === type.id}
              onChange={() => handleTripTypeSelect(type)}
              className={`form-radio h-4 w-4 text-blue-600
                border-gray-300 hidden focus:ring-blue-500`}
            />
            <span className="text-gray-700">{type.label}</span>
          </label>
        ))}
      </div>
    </>
  );
};

TripType.propTypes = {
  selectedType: PropTypes.object.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  onSetLocationType: PropTypes.func.isRequired
}

export default TripType;
